$(document).ready(function() {
	
	$(".elements-tab-nav .tab-link").click(function(e){
		e.preventDefault();
		e.stopPropagation();
		$(this).closest(".tab-parent").find(".active").removeClass("active");
		$(this).addClass("active");
		$(this).closest(".tab-parent").find($(this).attr("href")).addClass("active");
	});
});